export default [
  "WHOLESALE",
  "CUSTOM"
]
